module.exports = __webpack_public_path__ + "img/ic_arrow_down.85b4d2fc.svg";